<div class="layoutBlock">
	<div class="columnThreeQuarter">
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
		<res-publication-panel [selectedPublications]="researchInfrastructure.publications"
			[dynamicComponent]="researchInfrastructure._dynamicComponent"
			[hisDynamicContent]="'fs.res.common.publications'" 
			[dDKey]="'fs.res.researchInfrastructure.ResearchInfrastructure.publications'" 
			[isOptional]="true"
			(selectedPublicationsChange)="onPublicationsChange($event)"
			(routerContextChange)="onRouterContextChange()">
		</res-publication-panel>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	</div>
</div>